<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="&Scaron;tampači M3250, MS622">
     &Scaron;tampači M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sr" title="Bezbednosne informacije">
     Bezbednosne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvencije">
      Konvencije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Izjave o proizvodu">
      Izjave o proizvodu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sr" title="Saznajte vi&scaron;e o &scaron;tampaču">
     Saznajte vi&scaron;e o &scaron;tampaču
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sr" title="Pronalaženje informacija o &scaron;tampaču">
      Pronalaženje informacija o &scaron;tampaču
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sr" title="Izbor lokacije za &scaron;tampač">
      Izbor lokacije za &scaron;tampač
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sr" title="Konfiguracije &scaron;tampača">
      Konfiguracije &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sr" title="Povezivanje kablova">
      Povezivanje kablova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sr" title="Kori&scaron;ćenje kontrolne table">
      Kori&scaron;ćenje kontrolne table
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sr" title="Razumevanje statusa dugmeta za napajanje i indikatora">
      Razumevanje statusa dugmeta za napajanje i indikatora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_sr" title="&Scaron;tampanje stranice za pode&scaron;avanje mreže">
      &Scaron;tampanje stranice za pode&scaron;avanje mreže
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sr" title="Pode&scaron;avanje i kori&scaron;ćenje aplikacija na početnom ekranu">
     Pode&scaron;avanje i kori&scaron;ćenje aplikacija na početnom ekranu
    </a>
   </p>
   <div id="divd0e746">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sr" title="Kori&scaron;ćenje početnog ekrana">
      Kori&scaron;ćenje početnog ekrana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sr" title="Prilagođavanje početnog ekrana">
      Prilagođavanje početnog ekrana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_sr" title="Kori&scaron;ćenje Prilagođavanja ekrana">
      Kori&scaron;ćenje Prilagođavanja ekrana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_sr" title="Konfigurisanje ekolo&scaron;kih postavki">
      Konfigurisanje ekolo&scaron;kih postavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_sr" title="Kori&scaron;ćenje korisničke podr&scaron;ke">
      Kori&scaron;ćenje korisničke podr&scaron;ke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_sr" title="Kori&scaron;ćenje generatora QR koda">
      Kori&scaron;ćenje generatora QR koda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_sr" title="Pode&scaron;avanje kvota uređaja">
      Pode&scaron;avanje kvota uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_sr" title="Kreiranje Cloud Connector profila">
      Kreiranje Cloud Connector profila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1092" title="Upravljanje obeleživačima">
      Upravljanje obeleživačima
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1169" title="Upravljanje kontaktima">
      Upravljanje kontaktima
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_sr" title="Pode&scaron;avanje i upotreba funkcija za pristupačnost">
     Pode&scaron;avanje i upotreba funkcija za pristupačnost
    </a>
   </p>
   <div id="divd0e1288">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_sr" title="Aktiviranje glasovnog navođenja">
      Aktiviranje glasovnog navođenja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_sr" title="Kretanje po ekranu pomoću pokreta">
      Kretanje po ekranu pomoću pokreta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_sr" title="Omogućavanje režima uvećanja">
      Omogućavanje režima uvećanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_sr" title="Pode&scaron;avanje brzine govora za glasovno navođenje">
      Pode&scaron;avanje brzine govora za glasovno navođenje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_sr" title="Kori&scaron;ćenje tastature na ekranu">
      Kori&scaron;ćenje tastature na ekranu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_sr" title="Omogućavanje izgovaranja lozinki i PIN kodova">
      Omogućavanje izgovaranja lozinki i PIN kodova
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sr" title="Umetanje papira i specijalnih medija">
     Umetanje papira i specijalnih medija
    </a>
   </p>
   <div id="divd0e1493">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_sr" title="Pode&scaron;avanje veličine i tipa papira">
      Pode&scaron;avanje veličine i tipa papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_sr" title="Konfigurisanje univerzalnih postavki papira">
      Konfigurisanje univerzalnih postavki papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sr" title="Punjenje fioka">
      Punjenje fioka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_sr" title="Punjenje vi&scaron;enamenskog ulagača">
      Punjenje vi&scaron;enamenskog ulagača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_sr" title="Povezivanje fioka">
      Povezivanje fioka
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_sr" title="Paper support">
     Paper support
    </a>
   </p>
   <div id="divd0e1660">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_sr" title="Podržane veličine papira">
      Podržane veličine papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_sr" title="Podržani tipovi papira">
      Podržani tipovi papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_sr" title="Podržane težine papira">
      Podržane težine papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_sr" title="Neprihvatljiv papir">
      Neprihvatljiv papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_sr" title="Kori&scaron;ćenje recikliranog papira">
      Kori&scaron;ćenje recikliranog papira
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sr" title="&Scaron;tampanje">
     &Scaron;tampanje
    </a>
   </p>
   <div id="divd0e2519">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sr" title="&Scaron;tampanje sa računara">
      &Scaron;tampanje sa računara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2545" title="&Scaron;tampanje sa mobilnog uređaja">
      &Scaron;tampanje sa mobilnog uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sr" title="&Scaron;tampanje sa fle&scaron; uređaja">
      &Scaron;tampanje sa fle&scaron; uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sr" title="Podržani fle&scaron; uređaji i tipovi datoteka">
      Podržani fle&scaron; uređaji i tipovi datoteka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sr" title="Konfigurisanje poverljivih zadataka">
      Konfigurisanje poverljivih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sr" title="&Scaron;tampanje poverljivih i drugih zadržanih zadataka">
      &Scaron;tampanje poverljivih i drugih zadržanih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sr" title="&Scaron;tampanje sa Cloud Connector profila">
      &Scaron;tampanje sa Cloud Connector profila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sr" title="&Scaron;tampanje liste uzoraka fontova">
      &Scaron;tampanje liste uzoraka fontova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_sr" title="&Scaron;tampanje liste direktorijuma">
      &Scaron;tampanje liste direktorijuma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sr" title="Otkazivanje zadatka &scaron;tampe">
      Otkazivanje zadatka &scaron;tampe
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sr" title="Razumevanje menija &scaron;tampača">
     Razumevanje menija &scaron;tampača
    </a>
   </p>
   <div id="divd0e3055">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sr" title="Mapa menija">
      Mapa menija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3374" title="Uređaj">
      Uređaj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5220" title="&Scaron;tampaj">
      &Scaron;tampaj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6478" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6740" title="USB jedinica">
      USB jedinica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6961" title="Mreža/portovi">
      Mreža/portovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8751" title="Bezbednost">
      Bezbednost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9886" title="Izve&scaron;taji">
      Izve&scaron;taji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_sr" title="Pomoć">
      Pomoć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10134" title="Re&scaron;avanje problema">
      Re&scaron;avanje problema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sr" title="&Scaron;tampanje stranice sa postavkama menija">
      &Scaron;tampanje stranice sa postavkama menija
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sr" title="Obezbeđivanje &scaron;tampača">
     Obezbeđivanje &scaron;tampača
    </a>
   </p>
   <div id="divd0e10186">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sr" title="Lociranje bezbednosnog otvora">
      Lociranje bezbednosnog otvora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sr" title="Brisanje memorije &scaron;tampača">
      Brisanje memorije &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_sr" title="Brisanje memorije čvrstog diska &scaron;tampača">
      Brisanje memorije čvrstog diska &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_sr" title="&Scaron;ifrovanje čvrstog diska &scaron;tampača">
      &Scaron;ifrovanje čvrstog diska &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sr" title="Vraćanje podrazumevanih fabričkih postavki">
      Vraćanje podrazumevanih fabričkih postavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_sr" title="Izjava o nepostojanosti">
      Izjava o nepostojanosti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sr" title="Održavanje &scaron;tampača">
     Održavanje &scaron;tampača
    </a>
   </p>
   <div id="divd0e10400">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sr" title="Pode&scaron;avanje upozorenja e-po&scaron;tom">
      Pode&scaron;avanje upozorenja e-po&scaron;tom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_sr" title="Pode&scaron;avanje podrazumevane jačine zvuka slu&scaron;alica">
      Pode&scaron;avanje podrazumevane jačine zvuka slu&scaron;alica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10462" title="Umrežavanje">
      Umrežavanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_sr" title="Pode&scaron;avanje serijskog &scaron;tampanja (samo za Windows)">
      Pode&scaron;avanje serijskog &scaron;tampanja (samo za Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_sr" title="Či&scaron;ćenje &scaron;tampača">
      Či&scaron;ćenje &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sr" title="Naručivanje delova i potro&scaron;nog materijala">
      Naručivanje delova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11198" title="Zamena delova i potro&scaron;nog materijala">
      Zamena delova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11342" title="Preme&scaron;tanje &scaron;tampača">
      Preme&scaron;tanje &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11398" title="U&scaron;teda energije i papira">
      U&scaron;teda energije i papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11502" title="Recikliranje">
      Recikliranje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sr" title="Uklanjanje zaglavljivanja">
     Uklanjanje zaglavljivanja
    </a>
   </p>
   <div id="divd0e11535">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sr" title="Izbegavanje zaglavljivanja">
      Izbegavanje zaglavljivanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_sr" title="Utvrđivanje mesta zaglavljivanja papir">
      Utvrđivanje mesta zaglavljivanja papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_sr" title="Zaglavljen papir u vratima A">
      Zaglavljen papir u vratima A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_sr" title="Zaglavljen papir iza zadnjih vrata">
      Zaglavljen papir iza zadnjih vrata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_sr" title="Zaglavljen papir u standardnoj korpi">
      Zaglavljen papir u standardnoj korpi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_sr" title="Zaglavljen papir u jedinici dupleksa">
      Zaglavljen papir u jedinici dupleksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_sr" title="Zaglavljen papir u fiokama">
      Zaglavljen papir u fiokama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_sr" title="Zaglavljen papir u vi&scaron;enamenskom ulagaču">
      Zaglavljen papir u vi&scaron;enamenskom ulagaču
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sr" title="Re&scaron;avanje problema">
     Re&scaron;avanje problema
    </a>
   </p>
   <div id="divd0e11811">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11814" title="Problemi sa mrežnom vezom">
      Problemi sa mrežnom vezom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12128" title="Problemi sa hardverskim opcijama">
      Problemi sa hardverskim opcijama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12402" title="Problemi sa potro&scaron;nim materijalom">
      Problemi sa potro&scaron;nim materijalom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_sr" title="Problemi sa uvlačenjem papira">
      Problemi sa uvlačenjem papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sr" title="Problemi sa &scaron;tampanjem">
      Problemi sa &scaron;tampanjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sr" title="Kontaktiranje sa korisničkom podr&scaron;kom">
      Kontaktiranje sa korisničkom podr&scaron;kom
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_sr" title="Nadogradnja i migracija">
     Nadogradnja i migracija
    </a>
   </p>
   <div id="divd0e15394">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15397" title="Hardver">
      Hardver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15707" title="Softver">
      Softver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15790" title="Firmver">
      Firmver
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sr" title="Obave&scaron;tenja">
     Obave&scaron;tenja
    </a>
   </p>
   <div id="divd0e15876">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15879" title="Informacije o proizvodu">
      Informacije o proizvodu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15896" title="Obave&scaron;tenje o verziji">
      Obave&scaron;tenje o verziji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sr" title="Za&scaron;tićeni žigovi">
      Za&scaron;tićeni žigovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sr" title="Obave&scaron;tenja o licenciranju">
      Obave&scaron;tenja o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sr" title="Nivoi emisije buke">
      Nivoi emisije buke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sr" title="Direktiva o električnom i elektronskom otpadu (WEEE)">
      Direktiva o električnom i elektronskom otpadu (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16000" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sr" title="Odlaganje proizvoda">
      Odlaganje proizvoda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16034" title="Punjiva litijum-jonska baterija">
      Punjiva litijum-jonska baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sr" title="Уредба (ЕУ) 2023/1542">
      Уредба (ЕУ) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sr" title="Vraćanje kertridža kompanije Lexmark radi ponovne upotrebe ili reciklaže">
      Vraćanje kertridža kompanije Lexmark radi ponovne upotrebe ili reciklaže
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sr" title="Obave&scaron;tenje o osetljivosti na statički elektricitet">
      Obave&scaron;tenje o osetljivosti na statički elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sr" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sr" title="Obave&scaron;tenje o laseru">
      Obave&scaron;tenje o laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sr" title="Potro&scaron;nja energije">
      Potro&scaron;nja energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16274" title="Regulatorna obave&scaron;tenja za bežične proizvode">
      Regulatorna obave&scaron;tenja za bežične proizvode
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sr" title="Obave&scaron;tenje o modularnim komponentama">
      Obave&scaron;tenje o modularnim komponentama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sr" title="Izloženost radiofrekventnom zračenju">
      Izloženost radiofrekventnom zračenju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16300" title="Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)">
      Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sr" title="Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)">
      Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sr" title="Obave&scaron;tenje o radio smetnjama">
      Obave&scaron;tenje o radio smetnjama
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue